import type { HttpDto } from "~/http/http.models"

export class FileDto implements HttpDto<File> {
  readonly data: File
}
